module.exports = __webpack_public_path__ + "img/map-icon2.c7947d3f.png";